// Generated by purs version 0.14.3
"use strict";
var $foreign = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/foreign/v6.0.1/src/Foreign/Keys.js");
var Control_Applicative = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Control/Applicative.purs");
var Control_Monad_Except_Trans = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/transformers/v5.2.0/src/Control/Monad/Except/Trans.purs");
var Data_Boolean = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Boolean.purs");
var Foreign = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/foreign/v6.0.1/src/Foreign.purs");
var keys = function (dictMonad) {
    return function (value) {
        if (Foreign.isNull(value)) {
            return Foreign.fail(dictMonad)(new Foreign.TypeMismatch("object", "null"));
        };
        if (Foreign.isUndefined(value)) {
            return Foreign.fail(dictMonad)(new Foreign.TypeMismatch("object", "undefined"));
        };
        if (Foreign.typeOf(value) === "object") {
            return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(dictMonad))($foreign.unsafeKeys(value));
        };
        if (Data_Boolean.otherwise) {
            return Foreign.fail(dictMonad)(new Foreign.TypeMismatch("object", Foreign.typeOf(value)));
        };
        throw new Error("Failed pattern match at Foreign.Keys (line 15, column 1 - line 15, column 60): " + [ value.constructor.name ]);
    };
};
module.exports = {
    keys: keys
};

